import {
  ExpGlobalDataDTO,
  GlobalDataVersionDTO,
  GlobalIngredientsDTO,
} from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';

export const USERSTORE = {
  name: 'USERSTORE',
  key: 'id',
};
export const VERSIONSTORE = {
  name: 'VERSIONSTORE',
  key: 'id',
};
export const ISSCREENROUTESTORE = {
  name: 'ISSCREENROUTESTORE',
  key: 'id',
};
export const ALLSCORESGROUPSSTORE = {
  name: 'ALLSCORESGROUPSSTORE',
  key: 'scoreGroupsId',
};
export const CAPTUREPROFILETUNINGVALUESSTORE = {
  name: 'CAPTUREPROFILETUNINGVALUESSTORE',
  key: 'id',
};
export const CONTAINERSSTORE = {
  name: 'CONTAINERSSTORE',
  key: 'id',
};
export const INCUBATIONTEMPSSTORE = {
  name: 'INCUBATIONTEMPSSTORE',
  key: 'id',
};
export const FAVOURITEINGREDIENTSTOCKSSTORE = {
  name: 'FAVOURITEINGREDIENTSTOCKSTORE',
  key: 'id',
};
export const INGREDIENTINGREDIENTTYPESTORE = {
  name: 'INGREDIENTINGREDIENTTYPESTORE',
  key: 'id',
};
export const INGREDIENTSTOCKSTORE = {
  name: 'INGREDIENTSTOCKSTORE',
  key: 'id',
};
export const INGREDIENTTYPESTORE = {
  name: 'INGREDIENTTYPESTORE',
  key: 'id',
};
export const INGREDIENTTYPECOLORSTORE = {
  name: 'INGREDIENTTYPECOLORSTORE',
  key: 'id',
};
export const INGREDIENTSSTORE = {
  name: 'INGREDIENTSSTORE',
  key: 'id',
};
export const LICENSEEDITIONSTORE = {
  name: 'LICENSEEDITIONSTORE',
  key: 'id',
};
export const MANUALSCOREGROUPSSTORE = {
  name: 'MANUALSCOREGROUPSSTORE',
  key: 'scoreGroupsId',
};
export const PROTEINFORMULATIONLISTSTORE = {
  name: 'PROTEINFORMULATIONLISTSTORE',
  key: 'id',
};
export const SCOREDEFNSTORE = {
  name: 'SCOREDEFNSTORE',
  key: 'wellDropScoreId',
};
export const SCREENLISTSTORE = {
  name: 'SCREENLISTSTORE',
  key: 'id',
};
export const SEEDLISTSTORE = {
  name: 'SEEDLISTSTORE',
  key: 'id',
};
export const SETUPTEMPSSTORE = {
  name: 'SETUPTEMPSSTORE',
  key: 'id',
};
export const INGREDIENTSWRAPPERSTORE = {
  name: 'INGREDIENTWRAPPERSTORE',
  key: 'id',
};

const OBJECTSTOREARRAY = [
  USERSTORE,
  VERSIONSTORE,
  ALLSCORESGROUPSSTORE,
  CAPTUREPROFILETUNINGVALUESSTORE,
  CONTAINERSSTORE,
  INCUBATIONTEMPSSTORE,
  FAVOURITEINGREDIENTSTOCKSSTORE,
  INGREDIENTINGREDIENTTYPESTORE,
  INGREDIENTSTOCKSTORE,
  INGREDIENTTYPESTORE,
  INGREDIENTTYPECOLORSTORE,
  INGREDIENTSSTORE,
  LICENSEEDITIONSTORE,
  MANUALSCOREGROUPSSTORE,
  PROTEINFORMULATIONLISTSTORE,
  SCOREDEFNSTORE,
  SCREENLISTSTORE,
  SEEDLISTSTORE,
  SETUPTEMPSSTORE,
  ISSCREENROUTESTORE,
];

const DB_NAME = 'GlobalData';
const DB_VERSION = 16;

export class IndexDBGlobal {
  public database: any;
  public db: any;

  constructor() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = this.upgradeDbHandler;
  }

  upgradeDbHandler(this: IDBOpenDBRequest, ev: IDBVersionChangeEvent): any {
    const db = this.result;
    const objectStoreLength = db.objectStoreNames.length;
    const tempDB: any[] = [];

    for (let i = 0; i < objectStoreLength; i++) {
      tempDB.push(db.objectStoreNames[i]);
    }

    for (let i = 0; i < OBJECTSTOREARRAY.length; i++) {
      const result = tempDB.find((str) => str == OBJECTSTOREARRAY[i].name);
      if (isNullOrUndefined(result)) {
        db.createObjectStore(OBJECTSTOREARRAY[i].name, {
          keyPath: OBJECTSTOREARRAY[i].key,
        });
      }
    }
  }

  async ReadIndexDb(storeName) {
    if (
      storeName === LICENSEEDITIONSTORE.name ||
      storeName === VERSIONSTORE.name ||
      storeName === ISSCREENROUTESTORE.name
    ) {
      const data: any = await this.#readIndexDb(storeName);
      return data.length > 0 ? data[0].value : null;
    } else if (storeName === INGREDIENTSWRAPPERSTORE.name) {
      return {
        favouriteIngredientStocks: await this.ReadIndexDb(
          FAVOURITEINGREDIENTSTOCKSSTORE.name,
        ),
        ingredientStock: await this.ReadIndexDb(INGREDIENTSTOCKSTORE.name),
        ingredientIngredientType: await this.ReadIndexDb(
          INGREDIENTINGREDIENTTYPESTORE.name,
        ),
        ingredientType: await this.ReadIndexDb(INGREDIENTTYPESTORE.name),
        ingredientTypeColor: await this.ReadIndexDb(INGREDIENTTYPECOLORSTORE.name),
        ingredients: await this.ReadIndexDb(INGREDIENTSSTORE.name),
      } as GlobalIngredientsDTO;
    } else {
      return await this.#readIndexDb(storeName);
    }
  }

  makeMutable(array) {
    return Array.isArray(array) ? [...array] : array;
  }

  async ReadGDataIndexDb(): Promise<ExpGlobalDataDTO> {
    return {
      scoreDefn: this.makeMutable(await this.ReadIndexDb(SCOREDEFNSTORE.name)),
      allScoresGroups: this.makeMutable(
        await this.ReadIndexDb(ALLSCORESGROUPSSTORE.name),
      ),
      manualScoreGroups: this.makeMutable(
        await this.ReadIndexDb(MANUALSCOREGROUPSSTORE.name),
      ),
      incubationTemps: this.makeMutable(
        await this.ReadIndexDb(INCUBATIONTEMPSSTORE.name),
      ),
      setupTemps: this.makeMutable(await this.ReadIndexDb(SETUPTEMPSSTORE.name)),
      users: this.makeMutable(await this.ReadIndexDb(USERSTORE.name)),
      containers: this.makeMutable(await this.ReadIndexDb(CONTAINERSSTORE.name)),
      ingredientData: {
        favouriteIngredientStocks: this.makeMutable(
          await this.ReadIndexDb(FAVOURITEINGREDIENTSTOCKSSTORE.name),
        ),
        ingredientStock: this.makeMutable(
          await this.ReadIndexDb(INGREDIENTSTOCKSTORE.name),
        ),
        ingredientIngredientType: this.makeMutable(
          await this.ReadIndexDb(INGREDIENTINGREDIENTTYPESTORE.name),
        ),
        ingredientType: this.makeMutable(
          await this.ReadIndexDb(INGREDIENTTYPESTORE.name),
        ),
        ingredientTypeColor: this.makeMutable(
          await this.ReadIndexDb(INGREDIENTTYPECOLORSTORE.name),
        ),
        ingredients: this.makeMutable(await this.ReadIndexDb(INGREDIENTSSTORE.name)),
      } as GlobalIngredientsDTO,
      captureProfileTuningValues: this.makeMutable(
        await this.ReadIndexDb(CAPTUREPROFILETUNINGVALUESSTORE.name),
      ),
      seedList: this.makeMutable(await this.ReadIndexDb(SEEDLISTSTORE.name)),
      proteinFormulationList: this.makeMutable(
        await this.ReadIndexDb(PROTEINFORMULATIONLISTSTORE.name),
      ),
      screenList: this.makeMutable(await this.ReadIndexDb(SCREENLISTSTORE.name)),
      licenseEdition: await this.ReadIndexDb(LICENSEEDITIONSTORE.name),
    } as ExpGlobalDataDTO;
  }

  async ReadVersion(): Promise<GlobalDataVersionDTO> {
    const data: any = await this.#readIndexDb(VERSIONSTORE.name);
    return data.length > 0 ? (data[0].value as GlobalDataVersionDTO) : null;
  }

  async writeJson(data) {
    this.#writeToIndexDb(data.users, USERSTORE.name);

    this.#writeToIndexDb(data.allScoresGroups, ALLSCORESGROUPSSTORE.name);

    this.#writeToIndexDb(
      data.captureProfileTuningValues,
      CAPTUREPROFILETUNINGVALUESSTORE.name,
    );

    this.#writeToIndexDb(data.containers, CONTAINERSSTORE.name);

    this.#writeToIndexDb(data.incubationTemps, INCUBATIONTEMPSSTORE.name);

    this.#writeToIndexDb(
      data.ingredientData?.favouriteIngredientStocks,
      FAVOURITEINGREDIENTSTOCKSSTORE.name,
    );

    this.#writeToIndexDb(
      data.ingredientData?.ingredientIngredientType,
      INGREDIENTINGREDIENTTYPESTORE.name,
    );

    this.#writeToIndexDb(data.ingredientData?.ingredientStock, INGREDIENTSTOCKSTORE.name);

    this.#writeToIndexDb(data.ingredientData?.ingredientType, INGREDIENTTYPESTORE.name);

    this.#writeToIndexDb(
      data.ingredientData?.ingredientTypeColor,
      INGREDIENTTYPECOLORSTORE.name,
    );

    this.#writeToIndexDb(data.ingredientData?.ingredients, INGREDIENTSSTORE.name);

    this.#writeToIndexDb(data.licenseEdition, LICENSEEDITIONSTORE.name);

    this.#writeToIndexDb(data.manualScoreGroups, MANUALSCOREGROUPSSTORE.name);

    this.#writeToIndexDb(data.proteinFormulationList, PROTEINFORMULATIONLISTSTORE.name);

    this.#writeToIndexDb(data.scoreDefn, SCOREDEFNSTORE.name);

    this.#writeToIndexDb(data.screenList, SCREENLISTSTORE.name);

    this.#writeToIndexDb(data.seedList, SEEDLISTSTORE.name);

    this.#writeToIndexDb(data.setupTemps, SETUPTEMPSSTORE.name);

    this.#writeToIndexDb(data.version, VERSIONSTORE.name);

    this.#writeToIndexDb(data.isScreenRoute, ISSCREENROUTESTORE.name);
    return true;
  }

  #writeToIndexDb(data, storename?: string) {
    if (!data) {
      return;
    }

    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;

    request.onupgradeneeded = this.upgradeDbHandler;

    request.onsuccess = (event) => {
      db = request.result;
      const transaction = db.transaction(storename, 'readwrite');

      const store = transaction.objectStore(storename);

      store.clear().onsuccess = function (evt) {
        if (Array.isArray(data)) {
          data.forEach((element) => {
            store.add(element);
          });
        } else {
          store.add({ id: 0, value: data });
        }
      };
    };

    request.onerror = function (event) {};
  }

  async #readIndexDb(storeName) {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;

    request.onupgradeneeded = this.upgradeDbHandler;

    return new Promise((resolve, reject) => {
      request.onsuccess = function (event) {
        db = request.result;
        const transaction = db.transaction(storeName, 'readwrite');
        const store = transaction.objectStore(storeName);

        const getAll = store.getAll();

        getAll.onsuccess = function (evt) {
          //const allWellsData = evt.target.result;
          resolve(evt.target.result); // Resolve with the retrieved data
        };

        getAll.onerror = function (evt) {
          reject(evt.target.error); // Reject with the error
        };
      };

      request.onerror = function (event) {
        reject(request.error); // Reject with the request error
      };
    });
  }
}
